/** @format */

import axios from 'axios';

import Notify from '../../../../../../components/Commons/Notify';

import { ENV_USER } from '../../../../../../components/Commons/Hooks/Variables/Enviroment';

export async function EditRecipes(id, name, image) {
	const token = localStorage.getItem('userToken');
	let returnResponse;
	let data = {
		info: {
			id: id,
			name: name,
			recipe: image,
		},
	};

	await axios({
		headers: {
			Authorization: 'Bearer ' + token,
		},
		method: 'POST',
		url: `${ENV_USER}/recipe/update`,
		data: data,
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				returnResponse = response.data.data;
			} else {
				Notify({
					title: `Error: ${response.data.error}`,
					colorTitle: 'ph-main-notification-error-title',
					description: `Problemas con el servicio:   ${response.data.message}`,
					time: 3,
					image: 'error',
					placement: 'topRight',
				});
			}
		})
		.catch((error) => {
			console.log(error);
			// Notify({
			// 	title: 'Problemas de Conexión',
			// 	colorTitle: 'ph-main-notification-error-title',
			// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
			// 	time: 4,
			// 	image: 'error',
			// 	placement: 'topRight',
			// });
		});
	return returnResponse;
}
